(function (Drupal, once) {
    Drupal.behaviors.a11yMisc = {
        attach(context) {
            const noResultElements = once('ariaLivePolite', '.views-no-result-text', context);
            noResultElements.forEach(item => {
                item.setAttribute('aria-live', 'polite');
            })

            const iframes = once('titleAdded', 'iframe', context);
            iframes.forEach(item => {
                if (!item.title) {
                    iframeTitleBasedOnSrc(item);
                }
            })

        },
    }

    function iframeTitleBasedOnSrc(iframe) {
        const iframeSrc = iframe.src;
        let titleBasedOnSrc = '';
        if (iframeSrc.includes('youtu')) {
            titleBasedOnSrc = 'Vidéo YouTube';
        } else if (iframeSrc.includes('vimeo')) {
            titleBasedOnSrc = 'Vidéo Vimeo';
        } else if (iframeSrc.includes('dailymotion')) {
            titleBasedOnSrc = 'Vidéo DailyMotion';
        } else if (iframeSrc.includes('fanlink')) {
            titleBasedOnSrc = 'Playlist Fanlink';
        }

        if (titleBasedOnSrc) {
            iframe.setAttribute('title', titleBasedOnSrc);
        }
    }
})(Drupal, once)
